import { TAddress, TPrevAddress } from '../types'

export const removeObjectEmptyValues = (object: TAddress | TPrevAddress) =>
  Object.fromEntries(Object.entries(object).filter(([, value]) => value))
